import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DateUtils } from '../../../../../shared/helpers/dateUtils';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'parent-info',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    ReactiveFormsModule
  ],
  templateUrl: './parent-info.component.html',
  styleUrl: './parent-info.component.css'
})
export class ParentInfoComponent implements OnInit, AfterViewInit{

  @Input() parentInterviewData: any;
  @Output() onSaveSection1 = new EventEmitter<any>();

  @ViewChild('datepickerInterviewDate') datepickerInterviewDate!: ElementRef;
  parentInfoForm: FormGroup = new FormGroup([]);

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.parentInfoForm = new FormGroup({
      parent_name: new FormControl(this.parentInterviewData?.parent_name || '', Validators.required),
      date_interview: new FormControl(this.parentInterviewData?.date_interview || DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()), Validators.required),
      time_interview: new FormControl(this.parentInterviewData?.time_interview || '11:00', Validators.required),
      person_conducting_interview: new FormControl(this.parentInterviewData?.person_conducting_interview || '', Validators.required),
    });
  }
  
  async ngAfterViewInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      // Dynamically import the Datepicker to avoid server-side loading
      const { Datepicker } = await import('flowbite-datepicker');
      if (this.datepickerInterviewDate) {
        new Datepicker(this.datepickerInterviewDate.nativeElement, {
          autohide: true,
          format: 'mm/dd/yyyy'
        });
        // set default value to display for incident date
        if (this.parentInterviewData?.date_interview) {
          // if date_of_incident is available, set it to the datepicker
          this.datepickerInterviewDate.nativeElement.value = DateUtils.formatDateForDisplay(this.parentInterviewData.date_interview);
        } else {
          // if date_of_incident is not available, set it to the current date
          this.datepickerInterviewDate.nativeElement.value = DateUtils.getCurrentFormattedDate();
        }
        this.datepickerInterviewDate.nativeElement.addEventListener('changeDate', (event: any) => {
          const formattedDate = DateUtils.formatDateForBackend(event.target.value);
          this.parentInfoForm.get('interview_date')?.setValue(formattedDate);
        });
      }
    }
  }

  saveParentInfo(): void {
    if (this.parentInfoForm.valid) {
      this.onSaveSection1.emit(this.parentInfoForm.value);
    }
  }


}
